export default __webpack_public_path__ + "static/media/gaikuang_w.21762268.png";